import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'
// 发送验证码
export function dyCardBagSendCaptcha(data) {
  return request({
    url: `${apiConfig.ECS}/dyCardBag/sendCaptcha`,
    method: 'post',
    hideErrorToast: true,
    data
  })
}
// 登录
export function dyCardBagLogin(data) {
  return request({
    url: `${apiConfig.ECS}/dyCardBag/login`,
    method: 'post',
    data
  })
}
// 详情分页查询
export function dyCardBagDetail(data) {
  return request({
    url: `${apiConfig.ECS}/dyCardBag/pages`,
    method: 'post',
    token: sessionStorage.getItem('dyCardBagToken'),
    data
  })
}
// 导出
export function dyCardBagExport(data) {
  return request({
    url: `${apiConfig.ECS}/dyCardBag/export`,
    method: 'post',
    token: sessionStorage.getItem('dyCardBagToken'),
    data
  })
}
// 导出分页列表
export function dyCardBagExportPage(data) {
  return request({
    url: `${apiConfig.ECS}/dyCardBag/pageExport`,
    method: 'post',
    token: sessionStorage.getItem('dyCardBagToken'),
    data
  })
}
// 平台下拉框
export function listPlatInfo(data) {
  return request({
    url: `${apiConfig.ECS}/dyCardBag/listPlatInfo`,
    method: 'post',
    token: sessionStorage.getItem('dyCardBagToken'),
    data
  })
}
